import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import DeferredButton from '@/components/parts/catalog/card/components/defer';
import { ACTION_ADD, ACTION_REMOVE, Item, Items } from '@/store/deferred';
import { SAVE, SAVED } from './const';
import { State as StateType } from '../types';

const CARD = 'activityCard';
const DEFERRED = 'deferred';
const deferred = namespace(DEFERRED);
const card = namespace(CARD);

@Component({
  components: { DeferredButton },
})
export default class PageActivityCardButtonDeferred extends Vue {
  // Vuex
  @card.State
  activity: StateType['activity'];

  @deferred.State items: Items;
  @deferred.State ready: boolean;
  @deferred.Action(ACTION_ADD) add: (item: Item) => void;
  @deferred.Action(ACTION_REMOVE) remove: (id: Item['id']) => void;

  // Computed
  get saved() {
    const { activity } = this;
    const id = activity.id;
    const index = this.items.findIndex((item) => item.id === id);
    return index >= 0;
  }

  get text() {
    return this.saved ? SAVED : SAVE;
  }

  // Methods
  toggle() {
    const { saved, activity } = this;

    const id = activity.id;
    const code = '';
    const imageSrc = activity.imageSrc;
    const note = activity.announce;
    const title = activity.name;
    const isActivity = true;

    if (saved) return this.remove(id);

    const image = {
      small: imageSrc,
    };
    this.add({
      id,
      code,
      title,
      image,
      note,
      isActivity,
      cop_multi_name: activity.copMultiName,
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/activities/card/button-deferred/script.ts